import {ReactElement, useContext} from 'react'
import {Trans} from 'react-i18next'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button'

import {getFormattedAmount} from '../../../../../common/utils'
import AppContext from '../../../../Common/contexts/AppContext'
import {Account} from '../../../../../graphql/types'
import {config} from '../../../../../config'
import {isTradesmarterAccount} from '../../../../../common/utils/accounts'
import messages from '../../../../../assets/messages'
import {useStyles} from './styles'

type WithdrawalSummaryFooterProps = {
  account: Account,
  isSubmitDisabled: boolean,
  amountToWithdraw: number,
  isAgreementTermsChecked: boolean,
  onIsAgreementTermsChange: () => void,
  redirectBack: () => void,
  onSubmit: () => void
}

function WithdrawalSummaryFooter(props: WithdrawalSummaryFooterProps): ReactElement {
  const {
    isSubmitDisabled,
    account,
    amountToWithdraw,
    isAgreementTermsChecked,
    onIsAgreementTermsChange,
    redirectBack,
    onSubmit,
  } = props
  const {currency} = account
  const classes = useStyles()
  const {locale} = useContext(AppContext)

  const termsLink = isTradesmarterAccount(account)
    ? config.weblinks.binaryTerms
    : config.weblinks.termsAndConditions.replace('{lang}', locale)

  return (
    <div className={classes.container}>
      <FormControlLabel
        classes={{label:classes.checkboxLabel}}
        control={<Checkbox checked={isAgreementTermsChecked} onChange={onIsAgreementTermsChange} color="primary" />}
        label={
          <Trans
            {...messages.termsAndConditionsAgreementLabel}
            components={[<a target="_blank" rel="noopener noreferrer" href={termsLink} className={classes.termsLink}>termsLink</a>]}
          />
        }
      />
      <div className={classes.actions}>
        <Trans
          {...messages.totalWithdrawal}
          values={{amount: getFormattedAmount({currency, amount: amountToWithdraw})}}
          components={[<span className={classes.amountToWithdraw} onClick={redirectBack}>amountToWithdraw</span>]}
        />
        <Button
          color='primary'
          disabled={isSubmitDisabled}
          variant='contained'
          onClick={onSubmit}
        >
          <Trans {...messages.continue} />
        </Button>
      </div>
    </div>
  )
}

export {WithdrawalSummaryFooter}
